import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'BrandZhihuIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-zhihu",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M14 6h6v12h-2l-2 2l-1 -2h-1z"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M4 12h6.5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M10.5 6h-5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M6 4c-.5 2.5 -1.5 3.5 -2.5 4.5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M8 6v7c0 4.5 -2 5.5 -4 7"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M11 18l-3 -5"
    }, null), _createTextVNode(" ")]);
  }
};